import bookContent from "./bookContent";
import markdownToChapter from "../utils/markdownToChapter";
import shortid from "shortid";

export const saveBookInLocalStorage = book =>
  localStorage.setItem("makers.book", JSON.stringify(book));

const addUserCodeFields = chapters =>
  chapters.map(chapter => ({
    ...chapter,
    content: chapter.content.map(item => {
      switch (item.type) {
        case "TABLE":
        case "TEXT":
        case "COMMANDS":
          return { ...item, id: shortid.generate() };
        case "REACT":
          return !!item.reactCodeUser
            ? item
            : {
                ...item,
                id: shortid.generate(),
                reactCodeUser: item.reactCode
              };
        case "PLAIN_JAVASCRIPT":
        case "PLAIN_JSX":
        case "PLAIN_HTML":
        case "PLAIN_CSS":
          return { ...item, id: shortid.generate() };
        case "HTML":
          return !!item.htmlCodeUser
            ? item
            : { ...item, id: shortid.generate(), htmlCodeUser: item.htmlCode };
        case "HTML_WITH_CSS":
          if (!!item.htmlCodeUser && !!item.cssCodeUser) {
            return item;
          } else if (!!item.htmlCodeUser && !item.cssCodeUser) {
            return {
              ...item,
              id: shortid.generate(),
              cssCodeUser: item.cssCode
            };
          } else if (!item.htmlCodeUser && !!item.cssCodeUser) {
            return {
              ...item,
              id: shortid.generate(),
              htmlCodeUser: item.htmlCode
            };
          } else {
            return {
              ...item,
              id: shortid.generate(),
              htmlCodeUser: item.htmlCode,
              cssCodeUser: item.cssCode
            };
          }
        default:
          return item;
      }
    })
  }));

// Called by Book.js in componentDidMount
// If there is a book in the local storage return it
// If not
export const getBookFromLocalStorage = () => {
  const book = JSON.parse(localStorage.getItem("makers.book"));
  if (book) {
    return book;
  } else {
    const chapters = bookContent.chapters.map(chapter => ({
      ...chapter,
      content: markdownToChapter(chapter.content)
    }));

    const chaptersWithUserCodeFields = addUserCodeFields(chapters);

    const book = {
      activeChapterId: 0,
      chapters: chaptersWithUserCodeFields
    };

    saveBookInLocalStorage(book);
    return book;
  }
};



// WEBPACK FOOTER //
// ./src/book/utils.js